export default function groupBy<T extends Record<K, PropertyKey>, K extends PropertyKey>(prop: K, array: T[]) {
  const groups = {} as Record<T[K], T[]>
  array.forEach((item) => {
    const id = item[prop]
    if (id in groups) groups[id].push(item)
    else groups[id] = [item]
  })
  return groups
}
